/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useState } from "react";
import { Document, Page, View, Font, Image, Text } from "@react-pdf/renderer";
import { ResultTable } from "../../types/types";
import CIMATRIlogo from "../../CIMATRIlogo.png";
import ASAElogo from "../../ASAElogo.png";

Font.register({
  family: "MontserratFamily",
  src: "../../styles/Montserrat-Regular.ttf",
  fontStyle: "normal",
  fontWeight: "normal",
  fonts: [],
});

const PdfGenerator: React.FC<{
  jsonResult: ResultTable[];
  LevelName: string;
  chartImage: any;
}> = ({ jsonResult, LevelName, chartImage }) => {
  const [chartDimensions, setChartDimensions] = useState({
    width: 600,
    height: 300,
  });

  let headingPaddingLeft;

  if (LevelName === "Transformative") {
    headingPaddingLeft = 70;
  } else if (LevelName === "Developing") {
    headingPaddingLeft = 84;
  } else if (LevelName === "Exploratory") {
    headingPaddingLeft = 84;
  } else if (LevelName === "Unaware") {
    headingPaddingLeft = 93;
  } else if (LevelName === "Mature") {
    headingPaddingLeft = 100;
  }

  useEffect(() => {
    const updateDimensions = () => {
      const screenWidth = window.innerWidth;
      // You can set your conditions based on screen width here
      let width = 600; // default width
      let height = 300; // default height

      if (screenWidth <= 600) {
        // For small screens like mobile
        width = 600;
        height = 280;
      }

      if (screenWidth >= 601 && screenWidth <= 900) {
        // For small screens like tablets
        width = 700;
        height = 320;
      }

      if (screenWidth >= 901 && screenWidth <= 1200) {
        // For small screens like tablets
        width = 720;
        height = 350;
      }

      if (screenWidth >= 1201 && screenWidth <= 1536) {
        // For small screens like tablets
        width = 720;
        height = 350;
      }

      // Update the state with the calculated dimensions
      setChartDimensions({ width, height });
    };

    // Call the function initially to set dimensions on component mount
    updateDimensions();

    // Add event listener to update dimensions when the window is resized
    window.addEventListener("resize", updateDimensions);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  return (
    <Document>
      <Page size="A4" style=
      {{ margin: 22 }}>
        <View style={{}}>
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: 245,  //when asae logo was there then marginLeft value is 207
              marginTop: 5,
              marginBottom: 5,
            }}
          >
            <Image
              src={CIMATRIlogo}
              style={{
                width: 60,
                height: 35,
                marginRight: 5, // Add some spacing between the images if needed
              }}
            />

            {/* <Image
              src={ASAElogo}
              style={{
                width: 60,
                height: 30,
              }}
            /> */}
          </View>
          <View style={{ marginBottom: 18 }}>
            <Text
              style={{
                paddingLeft: 15,
                fontSize: 19,
                textAlign: "center",
                width: 500,
                marginBottom: 9,
                color: "#000080",
                display: "flex",
                marginLeft: 15,
              }}
            >
              AI Maturity Assessment for Associations
            </Text>
            <View style={{ flexDirection: "row" }}>
              <Text
                style={{
                  // paddingLeft: 70,
                  paddingLeft: headingPaddingLeft,
                  fontSize: 15,
                  marginBottom: 7.2,
                }}
              >
                Your Overall Artificial Intelligence Maturity is{" "}
              </Text>
              <Text
                style={{
                  color: "green",
                  fontSize: 15,
                }}
              >
                {LevelName}
              </Text>
            </View>
          </View>
        </View>

        {/* Table data is here */}
        <View style={{ width: 545 }}>
          <View
            style={{
              flexDirection: "row",
              backgroundColor: "#45C2B1",
              paddingBottom: 5,
              marginLeft: 17,
              marginRight: 20,
              padding: 8,
              borderWidth: 1,
              borderTopWidth: 0,
              borderLeftWidth: 0,
              borderRightWidth: 0,
              borderColor: "#fff", // Border color set to background color to hide the top border
            }}
          >
            <View style={{ flex: 2, padding: 5 }}>
              <Text style={{ fontSize: 15, fontWeight: "bold", color: "#fff" }}>
                Dimension
              </Text>
            </View>
            <View style={{ flex: 1, padding: 5, textAlign: "center" }}>
              <Text style={{ fontSize: 15, fontWeight: "bold", color: "#fff" }}>
                Result
              </Text>
            </View>
            <View style={{ flex: 1, padding: 5, textAlign: "center" }}>
              <Text style={{ fontSize: 15, fontWeight: "bold", color: "#fff" }}>
                Level
              </Text>
            </View>
          </View>
          {jsonResult &&
            jsonResult.map((row) => (
              <View
                key={row.dimension}
                style={{
                  flexDirection: "row",
                  padding: 9,
                  marginLeft: 12,
                  marginRight: 20,
                  marginBottom: 5,
                  borderWidth: 1,
                  borderTopWidth: 0,
                  borderLeftWidth: 0,
                  borderRightWidth: 0,
                  borderColor: "#ddd", // Border color for the rows
                }}
              >
                <View style={{ flex: 2, padding: 5 }}>
                  <Text style={{ fontSize: 10 }}>{row.dimension}</Text>
                </View>
                <View style={{ flex: 1, padding: 5, textAlign: "center" }}>
                  <Text style={{ fontSize: 10 }}>{row.percentage}%</Text>
                </View>
                <View style={{ flex: 1, padding: 5, textAlign: "center" }}>
                  <Text style={{ fontSize: 10 }}>{row.level}</Text>
                </View>
              </View>
            ))}
        </View>

        {/* Chart data is here */}
        <View
          style={{
            marginTop: 36,
            marginBottom: 120,
            flex: 1,
            justifyContent: "center", // align vertically center
            alignItems: "center", // align horizontally center
          }}
        >
          <Image
            src={chartImage}
            style={{
              width: chartDimensions?.width,
              height: chartDimensions?.height,
              marginLeft: -78
            }}
          />
        </View>

        {/* Dimension names and narrative texts */}
        {jsonResult &&
          jsonResult.map((item) => (
            <View
              key={item.dimension}
              style={{
                display: "flex",
                marginBottom: 6,
                marginTop: 3,
              }}
            >
              <View
                style={{
                  marginTop: 8,
                  marginLeft: 18,
                  marginRight: 6,
                  width: 250,
                }}
              >
                <Text
                  style={{
                    fontWeight: "bold",
                    color: "#333",
                    fontSize: 15.6,
                  }}
                >
                  {item.dimension}:
                </Text>
              </View>
              <View
                style={{
                  margin: 18,
                  width: 500,
                }}
              >
                <Text
                  style={{
                    color: "#666",
                    fontSize: 14.4,
                  }}
                >
                  {item.narrative}
                </Text>
              </View>
            </View>
          ))}
      </Page>
    </Document>
  );
};

export default PdfGenerator;
